import { render } from "./UpdateGroupProductDataModal.vue?vue&type=template&id=21f9fe60"
import script from "./UpdateGroupProductDataModal.vue?vue&type=script&lang=js"
export * from "./UpdateGroupProductDataModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__